import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const CustomMetrics = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.994 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5-51 1.567-51 3.5 22.834 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M105.871 128.28C95.768 135.65 83.317 140 69.85 140a60.935 60.935 0 0 1-38.852-13.914l11.207-11.198 13.404 13.393 25.131-25.112 25.131 25.111Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M95.159 134.538C87.446 138.046 78.877 140 69.85 140c-12.763 0-24.614-3.907-34.418-10.589l6.773-6.153 13.404 10.045 25.131-8.37 14.419 9.605Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.817 124.854c.279-.248.556-.497.83-.748a.5.5 0 1 0-.676-.737c-.54.495-1.089.981-1.646 1.457a.51.51 0 0 0-.186.343.503.503 0 0 0 .274.496.498.498 0 0 0 .561-.079c.283-.241.564-.485.843-.732Zm3.274-4.556a.497.497 0 0 0-.106.555.493.493 0 0 0 .284.268.5.5 0 0 0 .548-.136 61.766 61.766 0 0 0 4.316-5.089.501.501 0 0 0-.797-.605 60.844 60.844 0 0 1-4.245 5.007Zm-9.417 9.343a.504.504 0 0 0 .208-.515.506.506 0 0 0-.397-.389.474.474 0 0 0-.195.002.487.487 0 0 0-.18.076 60.716 60.716 0 0 1-3.7 2.336.499.499 0 0 0 .124.916.498.498 0 0 0 .379-.051 61.929 61.929 0 0 0 3.761-2.375Zm-5.706 3.46a.502.502 0 0 0-.091-.92.5.5 0 0 0-.38.038c-18.15 9.695-39.99 9.416-57.775-.37a.49.49 0 0 0-.38-.042.494.494 0 0 0-.358.424.5.5 0 0 0 .255.494c18.08 9.947 40.278 10.232 58.73.376Zm24.138-25.146a.494.494 0 0 0-.042.38.496.496 0 0 0 .619.342.494.494 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.501.501 0 0 0-.883.47c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.5.5 0 0 0 .865-.503 60.76 60.76 0 0 0-2.374-3.762.5.5 0 0 0-.826.564 60.066 60.066 0 0 1 2.335 3.7v.001ZM32.778 127.88a.492.492 0 0 0 .7-.097.492.492 0 0 0 .097-.37.503.503 0 0 0-.193-.33 60.489 60.489 0 0 1-5.007-4.244.499.499 0 0 0-.686.04.5.5 0 0 0 0 .687 61.512 61.512 0 0 0 5.09 4.314Zm-8.212-7.484a.5.5 0 1 0 .737-.676 60.47 60.47 0 0 1-.7-.776c-22.14-25.07-19.772-63.358 5.304-85.543 25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718 61.894 61.894 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a62.576 62.576 0 0 0-3.805-3.926.48.48 0 0 0-.065-.073 61.224 61.224 0 0 0-5.09-4.314.495.495 0 0 0-.128-.071 61.21 61.21 0 0 0-7.187-4.653.499.499 0 0 0-.146-.12c-18.08-9.949-40.278-10.234-58.728-.377a.497.497 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.488 61.488 0 0 0-3.762 2.375.499.499 0 0 0-.195.262 62.18 62.18 0 0 0-4.8 3.673.498.498 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.498.498 0 0 0-.156.288 62.411 62.411 0 0 0-2.724 2.682.498.498 0 0 0-.29.151 61.643 61.643 0 0 0-4.316 5.089.497.497 0 0 0-.102.308 61.214 61.214 0 0 0-4.513 6.935.498.498 0 0 0-.234.215C6.04 67.072 5.734 89.27 15.575 107.715c.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.251 61.251 0 0 0 2.373 3.763.488.488 0 0 0 .076.087 62.06 62.06 0 0 0 4.71 6.056l.036.04.043.048c.221.25.443.497.67.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.994 21h79v76h-79V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.994 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM40.903 30.048H26.744a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V31.048a1 1 0 0 0-1-1ZM62.448 30.048H48.289a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V31.048a1 1 0 0 0-1-1ZM83.994 30.048H69.835a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V31.048a1 1 0 0 0-1-1ZM40.903 48.143H26.744a1 1 0 0 0-1 1V59.81a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V49.143a1 1 0 0 0-1-1ZM62.448 48.143H48.289a1 1 0 0 0-1 1V59.81a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V49.143a1 1 0 0 0-1-1ZM83.994 48.143H69.835a1 1 0 0 0-1 1V59.81a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V49.143a1 1 0 0 0-1-1ZM40.903 66.238H26.744a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V67.238a1 1 0 0 0-1-1ZM62.448 66.238H48.289a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V67.238a1 1 0 0 0-1-1ZM83.994 66.238H69.835a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V67.238a1 1 0 0 0-1-1ZM40.903 84.333H26.744a1 1 0 0 0-1 1V96a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V85.333a1 1 0 0 0-1-1ZM62.448 84.333H48.289a1 1 0 0 0-1 1V96a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V85.333a1 1 0 0 0-1-1ZM83.994 84.333H69.835a1 1 0 0 0-1 1V96a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V85.333a1 1 0 0 0-1-1ZM39.203 21H26.649a.905.905 0 0 0 0 1.81h12.554a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M84.089 21h-5.372a.905.905 0 0 0 0 1.81h5.372a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M75.112 21H69.74a.905.905 0 0 0 0 1.81h5.372a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.816 24.619h-7.167a.905.905 0 0 0 0 1.81h7.167a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.214c7.403 0 13.404-5.997 13.404-13.394s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.674 1.674 0 0 0 1.676 1.676 1.677 1.677 0 0 0 1.676-1.676v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35l-.001-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M104.494 1.637c-11.25 1.244-20 10.782-20 22.363 0 12.426 10.073 22.5 22.5 22.5 11.581 0 21.119-8.75 22.362-20h-24.862V1.637Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M104.494 1.637c-11.25 1.244-20 10.782-20 22.363 0 12.426 10.073 22.5 22.5 22.5 11.581 0 21.119-8.75 22.362-20h-24.862V1.637Z"
      />
      <path
        fill={primary}
        d="M128.213 16.5h-13.719V2.78a22.571 22.571 0 0 1 13.719 13.72Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M104.494 1.637c-11.25 1.244-20 10.782-20 22.363 0 12.426 10.073 22.5 22.5 22.5 11.581 0 21.119-8.75 22.362-20h-24.862V1.637Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M128.213 16.5h-13.719V2.78a22.571 22.571 0 0 1 13.719 13.72Z"
      />
      <path
        fill="#fff"
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        fill={primary}
        d="M126.094 78.1c0-.331.246-.6.55-.6h1.1c.303 0 .55.269.55.6v3c0 .331-.247.6-.55.6h-1.1c-.304 0-.55-.269-.55-.6v-3Zm3.3-2.4c0-.331.246-.6.55-.6h1.1c.303 0 .55.269.55.6v5.4c0 .331-.247.6-.55.6h-1.1c-.304 0-.55-.269-.55-.6v-5.4Zm3.3-1.8c0-.331.246-.6.55-.6h1.1c.303 0 .55.269.55.6v7.2c0 .331-.247.6-.55.6h-1.1c-.304 0-.55-.269-.55-.6v-7.2Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.427"
          y2="113.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default CustomMetrics;
